import React from 'react';

interface NewProspect {
  prenom: string;
  nom: string;
  email: string;
  linkedin: string;
  site_url: string;
}

interface AddProspectModalProps {
  isOpen: boolean;
  prospect: NewProspect;
  onClose: () => void;
  onSave: () => void;
  onChange: (field: keyof NewProspect, value: string) => void;
}

const AddProspectModal: React.FC<AddProspectModalProps> = ({
  isOpen,
  prospect,
  onClose,
  onSave,
  onChange
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h2 className="text-xl font-bold mb-4">Ajouter un prospect</h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Prénom</label>
            <input
              type="text"
              value={prospect.prenom}
              onChange={(e) => onChange('prenom', e.target.value)}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Nom</label>
            <input
              type="text"
              value={prospect.nom}
              onChange={(e) => onChange('nom', e.target.value)}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              value={prospect.email}
              onChange={(e) => onChange('email', e.target.value)}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">LinkedIn (optionnel)</label>
            <input
              type="url"
              value={prospect.linkedin}
              onChange={(e) => onChange('linkedin', e.target.value)}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Site web (optionnel)</label>
            <input
              type="url"
              value={prospect.site_url}
              onChange={(e) => onChange('site_url', e.target.value)}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            />
          </div>
        </div>
        <div className="mt-6 flex justify-end gap-4">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 hover:text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors duration-150"
          >
            Annuler
          </button>
          <button
            onClick={onSave}
            className="px-4 py-2 bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white rounded-lg transition-colors duration-150"
          >
            Ajouter le prospect
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddProspectModal;
